import React, { useEffect, useState } from 'react';

const MAX_WEEKS = 15;

const WeeklyScoresPage = () => {
  const [currentWeek, setCurrentWeek] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Deployment-friendly base URL (env → localhost:5001 → Render fallback)
  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  // On mount: read current week (fallback to 1 if file missing) and set the selector
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${backendBase}/data/current_week.json`, { cache: 'no-store' });
        const data = await res.json();
        const wk = data?.currentWeek ?? data?.week ?? 1;
        if (!alive) return;
        setCurrentWeek(wk);
        setSelectedWeek(wk);
      } catch {
        if (!alive) return;
        setCurrentWeek(1);
        setSelectedWeek(1);
      }
    })();
    return () => { alive = false; };
  }, [backendBase]);

  // When selected week changes: load that week’s scores file
  useEffect(() => {
    if (!selectedWeek) return;
    setLoading(true);
    setError("");
    setScores([]);

    fetch(`${backendBase}/data/scores_week_${selectedWeek}.json`, { cache: 'no-store' })
      .then(res => {
        if (!res.ok) throw new Error('not-found');
        return res.json();
      })
      .then(data => {
        setScores(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setScores([]);
        setError(`No data yet for Week ${selectedWeek}.`);
      });
  }, [backendBase, selectedWeek]);

  return (
    <div className="page-container">
      <h2>Weekly Scores</h2>

      <div style={{ marginBottom: 12 }}>
        <label htmlFor="weekSelect" style={{ marginRight: 8 }}>Select Week:</label>
        <select
          id="weekSelect"
          value={selectedWeek ?? ''}
          onChange={(e) => setSelectedWeek(Number(e.target.value))}
        >
          {Array.from({ length: MAX_WEEKS }, (_, i) => i + 1).map(w => (
            <option key={w} value={w}>
              {`Week ${w}${currentWeek === w ? ' (current)' : ''}`}
            </option>
          ))}
        </select>
      </div>

      {loading && <p>Loading scores…</p>}
      {!loading && error && <p style={{ color: 'gray' }}>{error}</p>}

      {!loading && !error && scores.length === 0 && (
        <p style={{ color: 'gray' }}>No scores available for this week.</p>
      )}

      {!loading && scores.length > 0 && (
        <div>
          {scores.map((g, i) => (
            <p key={i}>
              {g.team1} ({g.score1}) {g.team2} ({g.score2})
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default WeeklyScoresPage;
